import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { SmartToy as BotIcon } from '@mui/icons-material';
import ChatMessageBubble from './ChatMessageBubble';
import SuggestedPromptChips from './SuggestedPromptChips';
import { DEFAULT_SUGGESTION_CHIPS } from './constants';

const ChatMessageList = ({
  messages,
  loading,
  loadingHint,
  messagesEndRef,
  showEmptyChips,
  welcomeChipLabels,
  suggestionChips,
  onChipSelect,
  errorBanner,
}) => {
  const followUpChips = suggestionChips?.length ? suggestionChips : [];
  const emptyLabels =
    welcomeChipLabels && welcomeChipLabels.length > 0 ? welcomeChipLabels : DEFAULT_SUGGESTION_CHIPS;

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: 'rgba(10, 18, 32, 0.65)',
      }}
    >
      {errorBanner}

      {messages.map((msg) => (
        <ChatMessageBubble key={msg.id} role={msg.role} text={msg.text} structured={msg.structured} />
      ))}

      {showEmptyChips && emptyLabels.length > 0 && (
        <Box sx={{ mt: 0.25 }}>
          <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.65)', display: 'block', mb: 1 }}>
            Try one of these (based on your current SafeSocial data when available):
          </Typography>
          <SuggestedPromptChips labels={emptyLabels} onSelect={onChipSelect} disabled={loading} />
        </Box>
      )}

      {!showEmptyChips && followUpChips.length > 0 && (
        <Box sx={{ pt: 0.5 }}>
          <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.55)', display: 'block', mb: 0.75 }}>
            Suggested follow-ups
          </Typography>
          <SuggestedPromptChips labels={followUpChips} onSelect={onChipSelect} disabled={loading} />
        </Box>
      )}

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
          <BotIcon fontSize="small" color="primary" />
          <Box
            sx={{
              px: 1.5,
              py: 1,
              borderRadius: '16px 16px 16px 4px',
              bgcolor: 'rgba(22, 35, 58, 0.95)',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <CircularProgress size={16} />
            {loadingHint ? (
              <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.75)' }}>
                {loadingHint}
              </Typography>
            ) : null}
          </Box>
        </Box>
      )}

      <div ref={messagesEndRef} />
    </Box>
  );
};

export default ChatMessageList;
